// Module should contain the storage keys used in the application

export const LOCALISATION_SELECTED = '__v-i18n-loc__';
